export { default as AnalyticsPayerMixTable } from './AnalyticsPayerMixTable';
